export default __webpack_public_path__ + "static/media/scratch1.a9269923.mp3";